import * as React from "react";
import {
  FaBuilding,
  FaCalendar,
  FaCar,
  FaChartLine,
  FaChartPie,
  FaCodeBranch,
  FaHome,
  FaLock,
  FaNetworkWired,
  FaProjectDiagram,
  FaRoute,
  FaSign,
  FaUserFriends,
  FaWifi
} from "react-icons/fa";
import AgenciesPage from "../pages/agencies";
import CompaniesPage from "../pages/companies";
import DeviceHistoryPage from "../pages/device_history";
import DevicesPage from "../pages/devices";
import HolidaysPage from "../pages/holidays";
import { default as HomePage } from "../pages/home";
import IntegrationsPage from "../pages/integrations";
import InvitePage from "../pages/invite";
import LoginPage from "../pages/login";
import PrivacyPage from "../pages/privacy";
import RecoverPage from "../pages/recover";
import ReportsPage from "../pages/reports";
import RoutesPage from "../pages/routes";
import SignupPage from "../pages/signup";
import TriggersPage from "../pages/triggers";
import UsersPage from "../pages/users";
import VehiclesPage from "../pages/vehicles";
import CommandsPage from "../pages/commands";
import AdminPage from "../pages/admin";

export interface RouteProps {
  title: string;
  key: string;
  icon?: React.ReactNode;
  url: string;
  component: React.ReactNode;
  private?: boolean;
  menu?: boolean;
  condition?: (data: { user: any; currentCompany: {company: any; role?: any} }) => boolean;
}
const routes: RouteProps[] = [
  {
    title: "Login",
    key: "login",
    icon: <FaLock />,
    url: "/login",
    component: <LoginPage />,
  },
  {
    title: "Privacidade",
    key: "privacy",
    url: "/privacidade",
    component: <PrivacyPage />,
  },
  {
    title: "Cadastro",
    key: "signup",
    icon: <FaSign />,
    url: "/cadastrar",
    component: <SignupPage />,
  },
  {
    title: "Cadastro",
    key: "signup-company",
    icon: <FaSign />,
    url: "/cadastrar/empresa",
    component: <SignupPage company />,
  },
  {
    title: "Convite",
    key: "invite",
    url: "/convite/:key",
    component: <InvitePage />,
  },
  {
    title: "Recuperar senha",
    key: "recover",
    url: "/recuperacao/:key",
    component: <RecoverPage />,
  },
  {
    title: "Início",
    key: "home",
    icon: <FaHome />,
    url: "/",
    menu: true,
    private: true,
    component: <HomePage />,
  },
  // {
  //   title: "Agências",
  //   key: "agencies",
  //   icon: <FaBuilding />,
  //   url: "/agencias",
  //   menu: true,
  //   private: true,
  //   component: <AgenciesPage />,
  // },
  {
    title: "Itinerários",
    key: "routes",
    icon: <FaRoute />,
    url: "/itinerarios",
    menu: true,
    private: true,
    component: <RoutesPage />,
    condition: ({ currentCompany }) => { return currentCompany?.company?.resources?.trips },
  },
  {
    title: "Veículos",
    key: "vehicles",
    icon: <FaCar />,
    url: "/veiculos",
    menu: true,
    private: true,
    component: <VehiclesPage />,
  },
  {
    title: "Dispositivos",
    key: "devices",
    icon: <FaWifi />,
    url: "/dispositivos",
    menu: true,
    private: true,
    component: <DevicesPage />,
    condition: ({ currentCompany }) => { return !["Cliente", "Agente", "Motorista"].includes(currentCompany?.role?.profile?.title); },
  },
  {
    title: "Dispositivos",
    key: "device-history",
    url: "/dispositivos/:deviceId/historico",
    menu: false,
    private: true,
    component: <DeviceHistoryPage />,
  },
  {
    title: "Usuários",
    key: "users",
    url: "/usuarios",
    icon: <FaUserFriends />,
    menu: true,
    private: true,
    component: <UsersPage />,
  },
  {
    title: "Relatórios",
    key: "reports",
    url: "/relatorios",
    icon: <FaChartLine />,
    menu: true,
    private: true,
    component: <ReportsPage />,
  },
  {
    title: "Feriados e recessos",
    key: "holidays",
    url: "/feriados",
    icon: <FaCalendar />,
    menu: true,
    private: true,
    component: <HolidaysPage />,
    condition: ({ currentCompany }) => { return currentCompany?.company?.resources?.trips },
  },
  {
    title: "Clientes",
    key: "companies-children",
    url: "/clientes",
    icon: <FaNetworkWired />,
    menu: true,
    private: true,
    component: <CompaniesPage />,
    condition: ({ user, currentCompany }) => { return (
      (user?.isAdmin || currentCompany?.company?.master) &&
      !["Cliente", "Agente", "Motorista"].includes(currentCompany?.role?.profile?.title)
    ) },
  },
  {
    title: "Automações",
    key: "triggers",
    url: "/automacoes",
    icon: <FaProjectDiagram />,
    menu: true,
    private: true,
    component: <TriggersPage />,
    condition: ({ currentCompany }) => { return !["Cliente", "Agente", "Motorista"].includes(currentCompany?.role?.profile?.title); },
  },
  {
    title: "Integrações",
    key: "integrations",
    url: "/integracoes",
    icon: <FaCodeBranch />,
    menu: true,
    private: true,
    component: <IntegrationsPage />,
    condition: ({ currentCompany }) => { return !["Cliente", "Agente", "Motorista"].includes(currentCompany?.role?.profile?.title); },
  },
  {
    title: "Comandos",
    key: "commands",
    url: "/comandos",
    icon: <FaCodeBranch />,
    menu: false,
    private: true,
    component: <CommandsPage />,
    condition: ({ currentCompany }) => { return !["Cliente", "Agente", "Motorista"].includes(currentCompany?.role?.profile?.title); },
  },
  {
    title: "Admin",
    key: "admin",
    url: "/admin-satify",
    icon: <FaChartPie />,
    menu: true,
    private: true,
    component: <AdminPage />,
    condition: ({ currentCompany, user }) => !!user?.isAdmin || !!currentCompany?.company?.master,
  },
];

export default routes;
